import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import "./addstatus.css";
const StatusText = ({ status }) => {
  return <span className="status-text">{status}</span>;
};

const metrics = [
  { label: "Total Campaigns", value: "25" },
  { label: "Active Campaigns", value: "18" },
  { label: "Total Spend", value: "$1,500" },
  { label: "Impressions", value: "120,000" },
  { label: "Clicks", value: "3,000" },
  { label: "CTR", value: "2.5%" },
];

const rows = [
  {
    name: "Summer Sale",
    type: "Video",
    status: "Active",
    start: "2024-07-01",
    end: "2024-07-31",
    budget: 500,
    spend: 350,
    impressions: 50000,
    clicks: 1500,
    ctr: "3.0%",
    conversions: 75,
  },
  {
    name: "Back to School",
    type: "Image",
    status: "Paused",
    start: "2024-08-15",
    end: "2024-09-15",
    budget: 300,
    spend: 150,
    impressions: 30000,
    clicks: 600,
    ctr: "2.0%",
    conversions: 30,
  },
  {
    name: "Holiday Promotion",
    type: "Banner",
    status: "Completed",
    start: "2023-12-01",
    end: "2023-12-31",
    budget: 700,
    spend: 700,
    impressions: 70000,
    clicks: 700,
    ctr: "1.0%",
    conversions: 70,
  },
  {
    name: "Spring Collection",
    type: "Carousel",
    status: "Rejected",
    start: "2024-03-01",
    end: "2024-03-31",
    budget: 200,
    spend: 0,
    impressions: 0,
    clicks: 0,
    ctr: "0.0%",
    conversions: 0,
  },
  {
    name: "New Product Launch",
    type: "Video",
    status: "Active",
    start: "2024-07-15",
    end: "2024-08-15",
    budget: 800,
    spend: 200,
    impressions: 40000,
    clicks: 1000,
    ctr: "2.5%",
    conversions: 50,
  },

  {
    name: "New Product Launch",
    type: "Video",
    status: "Active",
    start: "2024-07-15",
    end: "2024-08-15",
    budget: 800,
    spend: 200,
    impressions: 40000,
    clicks: 1000,
    ctr: "2.5%",
    conversions: 50,
  },

  {
    name: "New Product Launch",
    type: "Video",
    status: "Active",
    start: "2024-07-15",
    end: "2024-08-15",
    budget: 800,
    spend: 200,
    impressions: 40000,
    clicks: 1000,
    ctr: "2.5%",
    conversions: 50,
  },

  {
    name: "New Product Launch",
    type: "Video",
    status: "Active",
    start: "2024-07-15",
    end: "2024-08-15",
    budget: 800,
    spend: 200,
    impressions: 40000,
    clicks: 1000,
    ctr: "2.5%",
    conversions: 50,
  },

  {
    name: "New Product Launch",
    type: "Video",
    status: "Active",
    start: "2024-07-15",
    end: "2024-08-15",
    budget: 800,
    spend: 200,
    impressions: 40000,
    clicks: 1000,
    ctr: "2.5%",
    conversions: 50,
  },
];

function formatMoney(num) {
  const n = Number(num || 0);
  return `$${n.toLocaleString()}`;
}

const AddStatus = () => {
  return (
    <Row >
      <Col lg="12" className="app-bg ">
        <div className="screenHeight">
          <h3 className="page-title mb-4">Campaigns Overview</h3>

          {/* Metrics */}
          <Row className="g-3 mb-3">
            {metrics.map((m) => (
              <Col key={m.label} xs={12} sm={6} lg={4} xl={2}>
                <Card className="stat-card h-100 border rounded">
                  <Card.Body className="d-flex flex-column justify-content-between">
                    <div className="muted-label mb-2">{m.label}</div>
                    <div className="big-value">{m.value}</div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Conversions wide card */}
          <Row className="mb-4">
            <Col xs={12}>
              <Card className="stat-card border rounded">
                <Card.Body className="d-flex flex-column">
                  <div className="muted-label mb-2">Conversions</div>
                  <div className="big-value">150</div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <h5 className="section-title mb-3">Campaign Details</h5>

          {/* Table Card */}
          <Card className="table-card">
            <div className="table-scroll noscroll">
              <Table hover responsive borderless className="align-middle mb-0">
                <thead>
                  <tr>
                    <th>Campaign Name</th>
                    <th>Ad Type</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th className="text-end">Budget</th>
                    <th className="text-end">Spend</th>
                    <th className="text-end">Impressions</th>
                    <th className="text-end">Clicks</th>
                    <th className="text-end">CTR</th>
                    <th className="text-end">Conversions</th>
                  </tr>
                </thead>
                <tbody >
                  {rows.map((r) => (
                    <tr key={r.name} className="p-3"                                                            >
                      <td className="fw-medium text-dark">{r.name}</td>
                      <td className="linkish">{r.type}</td>
                      <td>
                        <StatusText status={r.status} />
                      </td>
                      <td className="nowrap">{r.start}</td>
                      <td className="nowrap">{r.end}</td>
                      <td className="text-end">{formatMoney(r.budget)}</td>
                      <td className="text-end">{formatMoney(r.spend)}</td>
                      <td className="text-end">
                        {r.impressions.toLocaleString()}
                      </td>
                      <td className="text-end">{r.clicks.toLocaleString()}</td>
                      <td className="text-end">{r.ctr}</td>
                      <td className="text-end">
                        {r.conversions.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
  );
};

export default AddStatus;
